export default "__VITE_ASSET__CuCOQSnh__"